export default "__VITE_ASSET__BFHgp$UP__"